import React from 'react'
import Main from './Main page/Driver/Main'
import Header from './Main page/Hero section/Header'
import Carousal from './Main page/Carousal/Carousal'
import AnimatedPage from './AnimatedPage'
function Home() {
  return (
    <>
      <AnimatedPage/>
      <Header />
      <Main />
      <Carousal />
    </>
  )
}

export default Home
